import {lazy} from 'react';

export const AnimatedBarChartLazy = lazy(() => import(/* webpackChunkName: "animatedBarChart" */ '.'));
